import { Component } from "@angular/core";

@Component({
	selector: "caass-Visitor",
	templateUrl: "./Visitor.component.html",
})
export class VisitorComponent {}
